import { Navbar, NavbarBrand, Image, Container } from "react-bootstrap";

export default function NavMenu() {
    return (
        <div>
            <Navbar variant="dark" className="bg-light">
                <Container fluid={true}>
                    <NavbarBrand>
                        <a href="https://abpn.org">
                            <Image style={{ height: "80px" }} src="/verifycert/abpn_logo_color.png" title="American Board of Psychiatry and Neurology, Inc." />
                        </a>
                    </NavbarBrand>
                </Container>
            </Navbar>
        </div>
    );
}
